import { styled } from 'styled-components';
import { HEADER_HEIGHT } from '../../../components/Header/Header.styles';
import { CONTEXT_FILTER_HEIGHT } from '../../../components/ContextFilters/ContextFilters.styles';

export const DepthChartDrawerHeader = styled.header`
  display: flex;
  background-color: ${({ theme }) => theme.colours.canvas.secondary.main};
  margin-top: calc(${HEADER_HEIGHT} + ${CONTEXT_FILTER_HEIGHT});
  padding: ${({ theme }) => theme.sizing.medium};
  gap: ${({ theme }) => theme.sizing.small};

  h3 {
    display: flex;
    gap: ${({ theme }) => theme.sizing.small};
    ${({ theme }) => theme.typography.headingMedium}
    margin: 0;
    flex-grow: 2;
    line-height: 1.8;
  }
`;
DepthChartDrawerHeader.displayName = 'DepthChartDrawerHeader';

export const DepthChartDrawerContent = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: min-content;
  gap: ${({ theme }) => theme.sizing.medium};
  padding: ${({ theme }) => theme.sizing.medium};
  // height of the drawer minus the app header, context filter bar, and drawer header
  height: calc(100vh - ${HEADER_HEIGHT} - ${CONTEXT_FILTER_HEIGHT} - 3.5rem);
  overflow-y: auto;

  @media screen and (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 815px) {
    grid-template-columns: 1fr;
  }
`;
DepthChartDrawerContent.displayName = 'DepthChartDrawerContent';

export const DepthChartDrawerContentExport = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: min-content;
  gap: ${({ theme }) => theme.sizing.medium};
  padding: ${({ theme }) => theme.sizing.medium};
  overflow-y: auto;

  @media screen and (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 815px) {
    grid-template-columns: 1fr;
  }
`;
DepthChartDrawerContentExport.displayName = 'DepthChartDrawerContentExport';
